<button
  (click)="nav.toggleMenu(item())"
  class="side-nav-link"
  [attr.aria-expanded]="!collapseState"
>
  @if (item().icon) {
    <img [src]="nav.getIconSrc(item())" alt="" class="menu-icon" />
  }
  <span class="menu-text">{{ item().label }}</span>
  @if (item().badge; as badge) {
    <span [class]="`badge text-bg-${badge.variant}`">{{ badge.text }}</span>
  }
  @if (!item().badge) {
    <span class="menu-arrow">
      <ng-icon name="tablerChevronDown"></ng-icon>
    </span>
  }
</button>
<div #collapse="ngbCollapse" [(ngbCollapse)]="collapseState" class="collapse">
  <ul class="sub-menu">
    @for (child of item().children; track $index) {
      @if (!nav.hasSubMenu(child)) {
        <li app-menu-item [item]="child"></li>
      }
      @if (nav.hasSubMenu(child)) {
        <li
          app-menu-item-children
          [item]="child"
          [class.active]="nav.shouldHighlightParent(child)"
        ></li>
      }
    }
  </ul>
</div>
